export enum ETeacherProfileTabs {
  BASIC_INFO = 'BASIC_INFO',
  CERTIFICATIONS = 'CERTIFICATIONS'
}
